import { GroupByIdDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import type { CommunitiesDropdown } from 'modules/dashboard/components/Groups/types'
import { useGroupsWithPostPermission } from 'modules/posts/hooks/useGroupsWithPostPermission'

type Params = {
  communitiesDropdown: CommunitiesDropdown
}

export const useCanCreatePosts = ({ communitiesDropdown }: Params) => {
  const { canPostSomewhere } = useGroupsWithPostPermission()

  const groupId: string | undefined =
    communitiesDropdown.strategy === 'group' && typeof communitiesDropdown.value === 'string'
      ? communitiesDropdown.value
      : undefined

  const { data: groupData } = useQuery(GroupByIdDocument, {
    variables: { id: groupId ?? '0' },
    skip: !groupId,
    fetchPolicy: 'cache-and-network',
  })

  const groupToCheck = groupData?.posts.group

  if (groupToCheck?._policies?.addPosts) {
    return groupToCheck._policies.addPosts.can
  }

  return canPostSomewhere
}
